// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"914527ee","239":"88266175","453":"155990ed","732":"09c649a2"}[chunkId] + ".chunk.js";
};